import { getEvisearchSuggestions } from '~/api/suggestions/evisearchSuggestionsSource';
import { JsonApiListResponse } from '~/redux/api/ApiTypes';
import { SearchFilterApiResponse } from '~/redux/api/evisearch/searchTypes';
import { eviSearch } from '~/services/serviceInstances';

const CONTRACT_TYPE_LABEL = 'Contract Type';

const resolveContractTypeFilterId = async (): Promise<string | undefined> => {
  // Override user locale to retrieve consistent label value for the "Contract Type" filter,
  // so that it can be used to match the correct filter ID in the response regardless of the user's locale setting.
  const response: JsonApiListResponse<'filter', SearchFilterApiResponse> =
    await eviSearch.get('/filters', {
      params: { entity: 'document' },
      headers: { 'Accept-Language': 'en' },
    });
  const filter = response.data.find(
    (f) => f.attributes.label === CONTRACT_TYPE_LABEL,
  );
  return filter?.id;
};

export const getEvisearchContractTypes = async (): Promise<string[]> => {
  const filterId = await resolveContractTypeFilterId();
  if (!filterId) return [];

  const response = await getEvisearchSuggestions(filterId, 'document', '');
  return response.values.map((v) => String(v.display_value || v.value));
};
